export const CANCEL_SUBSCRIPTION_FEEDBACK = '/cancel-subscription-feedback'

const cancelSubscriptionFeedbackRoutes = [CANCEL_SUBSCRIPTION_FEEDBACK]

export default cancelSubscriptionFeedbackRoutes
